export class TeslSchema {

    static INITIATE_QUOTE_DATA = {
      "Submission": {
         "SubmissionLinesIncluded": "15145",
         "SubmissionApplicationReceivedDate": "08/15/2018",
         "SubmissionApplicationEnteredDate": "08/15/2018",
         "AcquisitionType": {
            "id": "1",
            "value": "Agency"
         },
         "SubmissionNewRenewal": {
            "id": "9",
            "value": "New Business"
         },
         "SubmissionDefaultEffectiveDate": "08/15/2018",
         "ProductJurisdiction": {
            "id": "21",
            "value": "Massachusetts"
         },
         "Underwriter": "1003669158",
         "SubmissionPrimaryAddressRef": "SubmissionAddress_Primary",
         "SubmissionMailingAddressRef": "SubmissionAddress_Mailing",
         "IsMailingAddressDifferentFromPrimaryAddress": "1",
         "PartnerRef": "Partner_1151069855",
         "GenericInstanceNumber": "1",
         "EntityisBusinessorPerson": {
            "id": "1",
            "value": "Individual"
         },
         "IncludedBusinessBusinessLegalEntityType": {
            "id": "1",
            "value": "Sole Proprietor"
         },
         "IncludedPersonPersonNameFirst": " ",
         "IncludedPersonPersonNameLast": " ",
         "IncludedPersonPersonEmailAddress": "a@abc.com",
         "SubmissionAddress": [
            {
               "attributes": {
                 "os_id": "SubmissionAddress_Primary",  
               },
               "AddressLine1": "Primary",
               "AddressCity": "AddressCity",
               "AddressStateProvince": {
                  "id": "21",
                  "value": "Massachusetts"
               },
               "AddressCounty": "AddressCounty",
               "AddressZIPCode": "01752",
               "AddressCountry": {
                  "id": "1",
                  "value": "United States"
               }
            },
            {
               "attributes": {
                 "os_id": "SubmissionAddress_Mailing",  
               },
               "AddressLine1": "Mailing",
               "AddressCity": "AddressCity",
               "AddressStateProvince": {
                  "id": "21",
                  "value": "Massachusetts"
               },
               "AddressCounty": "AddressCounty",
               "AddressZIPCode": "01752",
               "AddressCountry": {
                  "id": "1",
                  "value": "United States"
               }
            }
         ]
      }
    }

    static METHOD_UPDATE_DATA = {
      "QuoteTransaction": {
        "attributes": {
          "xmlns": "http://www.oneshield.com/DragonSchema",
          "xmlns:xsi": "http://www.w3.org/2001/XMLSchema",
          "os_st_id": "1203021555",
          "os_id": "QuoteTransaction_1203021555",
        },
        "PolicyTransactionPolicy": {

          "attributes":{
            "os_st_id": "1296636455",
            "os_id": "PolicyTransactionPolicy_1296636455"
        },
        "BillingAccountorPolicyLevel": {
          "id": "2",
          "value": "Policy"
        },
        "BillingTo": "2",
        "PolicyBillingMethod": "1",
        "PaymentPlanID": "29445",
        "Status": {
          "id": "24905",
          "code": "Pending Bind",
          "value": "Pending Bind"
        },
        "ReferencePrimaryAddressLine1": "",
        "ReferencePrimaryAddressCity": "",
        "ReferencePrimaryAddressState": "",
        "ReferencePrimaryAddressZIPCode": "",
        "ReferenceAccountInformationAddressLine1": "",
        "ReferenceAccountInformationAddressCity": "",
        "ReferenceAccountInformationAddressStateProvince": "",
        "ReferenceAccountInformationAddressZipCode": "",
        "ReferenceMailingAddressLine1": "",
        "ReferenceMailingAddressCity": "",
        "ReferenceMailingAddressState": "",
        "ReferenceMailingAddressZipCode": "",
        "ReferenceAccountInformationBillingAddressLine1": "",
        "ReferenceAccountInformationBillingAddressCity": "",
        "ReferenceAccountInformationBillingAddressStateProvince": "",
        "ReferenceAccountInformationBillingAddressZipCode": "",
        'ReferenceAccountInformationPreferredEmailAddress': '',
        'ReferenceAccountInformationPreferredPhoneNumber' : ""
      },
      "ReferenceCashTransferProfileForCCCreditDebitCardNumber": "1111111111111117",
      "ReferenceCashTransferProfileForCCCreditDebitCardType": "1",
      "ReferenceCashTransferProfileForCCFirstName": "fname",
      "ReferenceCashTransferProfileForCCLastName": "lname",
      "ReferenceCashTransferProfileForCCPayerType": "",
      "ReferenceCashTransferProfileForCCExpirationMonth": "4",
      "ReferenceCashTransferProfileForCCExpirationYear": "2019",
      "ReferenceCashTransferProfileForCCSecurityCode": "555",
      "ReferenceCoveragesIncludedPersonPersonNameFirst": " ",
      "ReferenceCoveragesIncludedPersonPersonNameLast": " "

      }
    }

    static COVERAGE_UPDATE_DATA = {
      "QuoteTransaction": {
        "attributes": {
          "xmlns": "http://www.oneshield.com/DragonSchema",
          "xmlns:xsi": "http://www.w3.org/2001/XMLSchema",
          "os_st_id": "1199738455",
          "os_id": "QuoteTransaction_1199738455"
        },
        "PolicyTransactionPolicy": {
          "attributes": {
            "os_st_id": "1199738655",
            "os_id": "PolicyTransactionPolicy_1199738655",
          },
          "Status": {
            "id": "15802",
            "code": "Completed",
            "value": "Completed"
          },
          "PolicyCommercial": {
            "attributes": {
              "os_st_id": "1199742155",
              "os_id": "PolicyCommercial_1199742155",
            },
            "PolicyFL": {
              "attributes": {
                "os_st_id": "1199742255",
                "os_id": "PolicyFL_1199742255",
              },
              "Businessindustryfocus": "1",
              "BusinessName": "",
              "Numberofemployees": "10",
              "Doyouownorrent": "1",
              "Averagemonthlysales": "100000",
              "Doyouhaveonlinesales": "2",
              "Doyouofferdelivery": "2",
              "DeliveriesWeek": "1",
              "Doyouemployadriver": "2",
              "Doyouownavehicle": "2",
              "ProtectsemployeesdrivingforyourbusinessTF": "1",
              "ProtectsyourdatacustomersinfoTF": "1",
              "ProtectsyourgoodsinyourtruckTF": "1",
              "ProtectsyouremployeesforworkrelatedaccidentsTF": "1",
              "ProtectsyourbusinessoperationsphysicalassetsTF": "1",
              "ProtectsyourgeneralliabilityTF": "1",
              "OnlineSalesPercentage": "30",
              'PropertyCoverageAmount': 0,
              'AccidentCoverageAmount': 0,
              'VehicleAndDriverCoverageAmount': 0,
              'GoodsCargoCoverageAmount': 0,
              'DataCoverageAmount': 0,
              'LiabilityCoverageAmount': 0,
              'Revenue': "0" // update for revenue
            }
          }
        },
        'QuoteCreatedByTESL': 1 //update for taxes
      }
    }  
}
